export const FETCH_GALLERY_PAGE = "fetchGalleryPage";
